import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Pipe({
  name: 'docRef',
})
export class DocRefPipe implements PipeTransform {
  constructor(private store: AngularFirestore) {}

  async transform(ref: firebase.default.firestore.DocumentReference, ...args: unknown[]): Promise<any> {
    let document = await ref.get();
    return document.data();
  }
}
